<template>
  <q-card
    class="q-mb-sm"
  >
    <q-item
      class="module-item q-py-xs q-px-sm"
      style="min-height: 0px;"
    >
      <q-item-section class="text-caption">
        <div
          class="cursor-pointer"
          @click="$emit('click')"
        >
          <span class="text-bold">
            {{ client.preferred_contact_name }}
          </span>
          <span
            v-if="client.pivot.relationship"
            class="q-ml-xs"
          >
            ({{ client.pivot.relationship }})
          </span>
        </div>
        <div v-if="client.email_address">
          Email:
          <basic-link class="inline-block" @click="goToEmail(client.email_address)">
            {{ client.email_address }}
          </basic-link>
        </div>
        <div v-if="client.primary_address">
          Address:
          <basic-link class="inline-block" @click="goToAddress(client.primary_address.full_address)">
            {{ client.primary_address.full_address }}
          </basic-link>
        </div>
        <div v-if="client.primary_phone">
          Phone:
          <basic-link class="inline-block" @click="goToPhone(client.primary_phone.full_phone)">
            {{ client.primary_phone.full_phone }}
          </basic-link>
        </div>
      </q-item-section>
      <q-item-section side>
        <profile-image
          size="sm"
          clickable
          :initials="client.initials"
          :profile-image="client.profile_image"
          @click="$emit('click')"
        />
      </q-item-section>
    </q-item>
  </q-card>
</template>

<script>
export default {
  props: {
    client: {
      type: Object,
      required: true
    }
  },
  emits: ['click']
}
</script>
